import { render } from "./legend.vue?vue&type=template&id=40f214a3&ts=true"
import script from "./legend.vue?vue&type=script&lang=ts"
export * from "./legend.vue?vue&type=script&lang=ts"

import exportComponent from "/home/asan/haisha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__